export default __webpack_public_path__ + "static/media/img_services08.369ba776.png";